import { create } from "zustand";
import * as api from "../services/userSettings";

export const useUserSettingsStore = create(() => ({
  getNotifications: async ({ userId }) => {
    return await api.getNotifications({ userId });
  },
  updateNotifications: async ({ userId, payload }) => {
    return await api.updateNotifications({ userId, payload });
  },
}));
